import type { ModuleNavigation } from '../../layouts/ModuleSidebar';

export const documentsNavigation: ModuleNavigation = [
  {
    title: 'Library',
    items: [
      { path: '/documents', label: 'Overview' },
      { path: '/documents/browse', label: 'All Documents' },
      { path: '/documents/browse?expiring=60', label: 'Expiring Soon (60d)' },
      { path: '/documents/browse?source=email', label: 'Email Attachments' },
    ],
  },
  {
    title: 'Templates',
    items: [
      { path: '/admin/document-templates', label: 'Document Templates' },
    ],
  },
];
